import React, { Component } from 'react';
import styled  from 'styled-components';
import EmailAddress from './emailaddress.component.js';
import Header from './header.component.js';
import pdf from '../images/pdf.svg';
import segel from '../images/sonnensegel.jpeg';
import spielhaus from '../images/spielhaus.jpeg';
import tonies from '../images/tonies.jpg';
import spielwandWichtel from '../images/spielwand-wichtel.jpg';
import gewinnspiel2021 from '../images/gewinnspiel2021.jpg';
import einladungMitgliederversammlung2021 from '../docs/Einladung_Mitgliederversammlung_2021.pdf';
import gewinnspiel2021Pdf from '../docs/Mach_mit_bei_Mr._Frozy_s_Weihnachtsgewinnspiel.pdf';
import kerzen from '../images/kerzen.jpg';
import adventskranz from '../images/adventskranz.jpg';
import zelte from '../images/zelte.jpg';
import wheelybugs from '../images/wheelybugs.jpg';
import kindersachenboerseMaerz2023 from '../images/KinderSachenBörseFlyerA4.png';
import kindersachenboerseMaerz2023Pdf from '../docs/KinderSachenBörseFlyerA4.pdf';
import aussenbaenke from '../images/Aussenbaenke.png';
import toniebox from '../images/toniebox.png';
import vorstand2025 from '../images/Vorstand2025.png';
import instagram from '../images/Instagram_Glyph_Black.svg'

const Background = styled.div`
    background-color:#f8f9fa !important; 
    border-radius:10px;
    padding: 10px;
    margin: 10px;
`;

const Padding50px = styled.div`
    padding-top:50px;
`

const UnorderedList = styled.div`
    display:inline-block !important;
    list-style-type:none;
`;

const OrderedList = styled.ol`
    display: inline-block;
    text-align: left;
`

const Bold = styled.span`
    font-weight:bold;
`

const Image = styled.img`
    max-height: ${props => props.maxHeight ? props.maxHeight : 'fit-content'};
`

const SocialMediaIcon = styled.img`
	height:40px !important;
`


class News extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }
      
	render() {
    	return (
            <div>
                <div className="container opacity90">
                    <Header text="Neuigkeiten" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Background>

                                <div>
                                    <span className="badge badge-primary">September 2025</span>
                                    <br />
                                    <h2>
                                        Wir stellen uns vor - Ihr neuer Vorstand des Fördervereins
                                    </h2>
                                    <br />
                                    <img className="img-fluid" src={vorstand2025} />
                                    <br />
                                    <br />
                                    Liebe Mitglieder, liebe Unterstützerinnen und Unterstützer,
                                    <br />
                                    wir freuen uns sehr, uns heute als Ihr neuer Vorstand des Fördervereins vorstellen zu dürfen.
                                    Mit frischem Schwung, vielen Ideen und viel Herz möchten wir die erfolgreiche Arbeit der vergangenen
                                    Jahre fortführen und weiterentwickeln.
                                    <br />
                                    Uns ist wichtig, dass der Förderverein auch in Zukunft ein lebendiger Teil unserer Gemeinschaft bleibt.
                                    Gemeinsam möchten wir bestehende Projekte weiterentwickeln, neue Initiativen anstoßen und die
                                    Verbindung zwischen Verein, Einrichtung und allen Mitgliedern stärken.
                                    <br />
                                    Wir sind überzeugt: Mit Engagement, Teamgeist und Ihrer Unterstützung können wir viel bewegen.
                                    Deshalb freuen wir uns auf eine offene Zusammenarbeit, auf Ihre Anregungen und natürlich auch darauf,
                                    gemeinsam schöne Aktionen und Erfolge zu erleben.
                                    <br />
                                    Herzlichen Dank für Ihr Vertrauen - wir packen es an!
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">September 2025</span>
                                    <br />
                                    <h2>
                                        KiTa Bongartzstift Förderverein jetzt auch auf Instagram
                                    </h2>
                                    <br />
                                    Seit kurzem sind wir auch auf der Plattform Instagram mit unserem Förderverein zu finden.
                                    <br />
                                    <a href="https://www.instagram.com/foerderverein_bongartzstift" target="_blank">
                                    <SocialMediaIcon src={instagram} className="img-fluid" />
                                    </a>
                                    <span> </span>
                                    <a href="https://www.instagram.com/foerderverein_bongartzstift" target="_blank">
                                        foerderverein_bongartzstift
                                    </a>
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">September 2023</span>
                                    <br />
                                    <h2>
                                        Gewinner des Stadtwerke Nettetal Preis
                                    </h2>
                                    <br />
                                    Unsere Kita hat am Stadtwerke Nettetal Preis teilgenommen. Wir freuen uns, dass unsere Kita Bongartzstift dabei den 1. Platz belegt hat. 
                                    <br />
                                    Herzlichen Glückwusch!
                                    <br />
                                    <br />
                                    Hier der Link zum Artikel bei der Rheinischen Post - Online:
                                    <br />
                                    <a href="https://rp-online.de/nrw/staedte/nettetal/nettetal-das-sind-die-gewinner-des-stadtwerke-preises_aid-98461123" target="_blank">
                                        https://rp-online.de/nrw/staedte/nettetal/nettetal-das-sind-die-gewinner-des-stadtwerke-preises_aid-98461123
                                    </a>
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                

                                <div>
                                    <span className="badge badge-primary">November 2023</span>
                                    <br />
                                    <h2>
                                        Neue Toniebox
                                    </h2>
                                    <br />
                                    Wir freuen uns sehr über die neue Toniebox in einem wunderschönen grün. 
                                    <br />
                                    Unsere Kitakinder hören die vielen verschiedenen Tonies bereits seit September rauf und runter.
                                    <br />
                                    Dankeschön!
                                    <br />
                                    <Image 
                                        src={toniebox} 
                                        className="img-fluid" 
                                        maxHeight="450px"
                                    />
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">November 2023</span>
                                    <br />
                                    <h2>
                                        Neue Außenbänke
                                    </h2>
                                    <br />
                                    Liebe Eltern,
                                    <br />
                                    der Förderverein hat für unsere kleinen Wichtel zwei
                                    wunderschöne Sitzgelegenheiten für den Außenbereich
                                    gespendet. Hier können wir nun unsere Trinkpausen mit den
                                    Kindern genießen und zwischendurch kurze, gemütliche
                                    Pausen einlegen.
                                    <br />
                                    Die Grünen und die Gelben Wichtel sagen ganz laut:
                                    <br />
                                    D A N K E S C H Ö Ö Ö N ! ! !
                                    <br />
                                    <img src={aussenbaenke} className="img-fluid" />
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">März 2023</span>
                                    <br />
                                    <h2>
                                        Kindersachenbörse
                                    </h2>
                                    <br />
                                    Nach nun rund drei Jahren Coronapause darf der Förderverein wieder den Kindentrödelmarkt durchführen.
                                    <br />
                                    Wir freuen uns auf zahlreiche Besucher und Teilnehmer.
                                    <br />
                                    <br />
                                    <Image
                                        maxHeight={"700px"} 
                                        src={kindersachenboerseMaerz2023} 
                                        alt="Kindersachenbörse 26. März 2023" 
                                        className="img-fluid" 
                                    />
                                    <br />
                                    <br />
                                    Flyer zum Download
                                    <br />
                                    <a href={kindersachenboerseMaerz2023Pdf} target="_blank" download>
                                        <img src={pdf} alt="PDF" className="height50px" />
                                    </a>
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">Januar 2023</span>
                                    <br />
                                    <h2>
                                        Unser Förderverein hat sich neu aufgestellt
                                    </h2>
                                    <br />
                                    Gerne möchten wir uns als neu gewählter Vorstand des Fördervereins vorstellen und danken schon jetzt für das entgegengebrachte Vertrauen. 
                                    Die Wahl fand am 05.01.2023 im Rahmen der Mitgliederversammlung statt.
                                    <br />
                                    Namentlich entfiel die Wahl auf: 
                                    <br />
                                    <br />
                                    1. Vorsitzende: Kathrin Funcke 
                                    <br />
                                    2. Vorsitzender: Nadine Grundmann
                                    <br />
                                    Kassiererin: Senem Bayazit
                                    <br />
                                    <br />
                                    Für das aktuelle Kindergartenjahr haben wir uns einiges vorgenommen und hoffen, dass wir zusammen mit Eurer Unterstützung vieles oder bestenfalls alles erreichen können.
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">November 2022</span>
                                    <br />
                                    <h2>
                                        Einladung zur Mitgliederversammlung
                                    </h2>
                                    <br />
                                    Liebe Mitglieder*innen,
                                    <br />
                                    wir laden Sie herzlich zu der diesjährigen Mitgliederversammlung des Fördervereins der Städtischen Kindertagesstätte Bongartzstift e.V. ein.
                                    <br />
                                    <br />
                                    Termin: 15.12.2022
                                    <br />
                                    Zeit: 19 Uhr
                                    <br />
                                    Ort: Bewegungsraum der Kindertagesstätte als auch Online via Teams.
                                    <br />
                                    Tagesordnung:
                                    <br />
                                    <OrderedList>
                                        <li>Begrüßung durch den Vorstand</li>
                                        <li>Wahl des Schriftführers</li>
                                        <li>Bericht des Vorstandes</li>
                                        <li>Bericht des Kassierers und der Kassenprüfer</li>
                                        <li>Entlastung des Vorstands und der Kassenprüfer</li>
                                        <li>Neuwahl des Vorstandes</li>
                                        <li>Verschiedenes</li>
                                    </OrderedList>
                                    <br />
                                    Anträge auf Ergänzungen der Tagesordnung müssen vor der Versammlung beim Vorstand eingereicht
                                    werden.
                                    <br />
                                    <br />
                                    Scheitert die Beschlussfähigkeit an der Anzahl der erschienenen Mitglieder, so findet eine zweite Mitgliederversammlung mit der gleichen Tagesordnung statt. Diese ist ohne Rücksicht auf die Anzahl der erschienenen Mitglieder beschlussfähig.
                                    Wir danken Ihnen für Ihr Verständnis und freuen uns, Sie an diesem Tag zahlreich bei uns begrüßen zu können.
                                    <br />
                                    <br />
                                    Gemeinsam können wir für die Kinder der Kita viel erreichen!
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">November 2022</span>
                                    <br />
                                    <h2>
                                        Spende vom Förderverein
                                    </h2>
                                    <br />
                                    Liebe Eltern,
                                    <br />
                                    diese schönen Adventsgestecke hat uns der Förderverein gespendet.
                                    <br />
                                    Ein herzliches Dankeschön von allen Gruppen an Frau Bayazit und den Förderverein!
                                    <br />
                                    <br />
                                    <img src={kerzen} alt="Adventskränze" className="img-fluid" />
                                    <br />
                                    <br />
                                    Besonders gut gefällt uns, dass die Farbauswahl zu den jeweiligen Gruppen passt-Tolle Idee!
                                    <br />
                                    <br />
                                    <img src={adventskranz} alt="Adventskranz" className="img-fluid" />
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">Mai 2022</span>
                                    <br />
                                    <h2>
                                        Spende vom Förderverein
                                    </h2>
                                    <br />
                                    <img src={zelte} alt="Tipis" className="img-fluid" />
                                    <br />
                                    <br />
                                    Die Kinderaugen haben geleuchtet! Sofort waren die Kinder ins Spiel vertieft und suchten Feuerholz.
                                    <br />
                                    <br />
                                    <img src={wheelybugs} alt="Wheely Bugs" className="img-fluid" />
                                    <br />
                                    <br />
                                    Die Wichtel lieben ihre neuen Fahrzeuge sehr!
                                    <br />
                                    Vielen lieben Dank lieber Förderverein für die Tipis und den tollen orangenen Käfer!
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">Dezember 2021</span>
                                    <br />
                                    <h2>
                                        Weihnachtsgewinnspiel 2021
                                    </h2>
                                    <br />
                                    Liebe Familien,
                                    <br />
                                    gemeinsam mit unserem Förderverein möchten wir als Familienzentrum zum
                                    Ende des Jahres noch ein kleines Weihnachtsgewinnspiel veranstalten! Helft
                                    uns herauszufinden wie viele Schneebälle der kleine Schneemann
                                    "Frosty" seinem Freund weggeschnappt und unter sich versteckt hat.
                                    Ab Freitag wird Frosty bis zum 16.12.2021 seinen Platz vor unserer
                                    Eingangstüre einnehmen. Dann heißt es für Euch
                                    <br />
                                    <br />
                                    <Bold>"Zählen, zählen, zählen!"</Bold>
                                    <br />
                                    <br />
                                    Schreibt Eure geschätzte Zahl auf die Lösungskarte und vergesst nicht Euren
                                    Familiennamen anzugeben. Dann werft die Karte in unseren Briefkasten
                                    links an der Wand.
                                    <br />
                                    Mit etwas Glück gehört Ihr bald schon zu unseren Gewinnern.
                                    Zu gewinnen gibt es Preise zum Beispiel von Leuf und Matussek im
                                    Gesamtwert von 200 Euro!
                                    <br />
                                    <img src={gewinnspiel2021} alt="Gewinnspiel 2021" className="img-fluid" />
                                    <br />
                                    <Bold>Als Hauptpreis winkt ein Kinogutschein für die ganze Familie im Wert von 60 € von unserem schönen Corso Filmcasino in Kaldenkirchen!</Bold>
                                    <br />
                                    <br />
                                    P.S.: Habt auch Ihr Lust unseren Förderverein zu unterstützen, dann könnt Ihr dies sehr
                                    gerne tun. Der Jahresbeitrag beläuft sich auf 12 Euro (also jeden Monat ein Euro). Nehmt
                                    Euch gerne einen Anmeldebogen mit und werft ihn ausgefüllt in den Briefkasten am
                                    Eingang. Dankeschön!
                                    <br />
                                    <a href={gewinnspiel2021Pdf} target="_blank" download><img src={pdf} alt="PDF" className="height50px" /></a>
                                    <br />
                                    Gewinnspiel
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">November 2021</span>
                                    <br />
                                    <h2>
                                        Einladung Mitgliederversammlung 2021
                                    </h2>
                                    <br />
                                    Liebe Mitglieder*innen,
                                    <br />
                                    wir laden herzlich alle Mitglieder zur jährlichen Mitgliederversammlung des Fördervereins der Städtischen Kindertagesstätte Bongartzstift e.V. ein:
                                    <br />
                                    Termin: <Bold>23. November 2021</Bold>
                                    <br />
                                    Zeit: <Bold>19:00 Uhr</Bold>
                                    <br />
                                    Ort: <Bold>Bewegungsraum der Kindertagesstätte Bongartzstift</Bold>
                                    <br />
                                    <br />
                                    Wir freuen uns viele Mitglieder begrüßen zu dürfen. 
                                    <br />
                                    <br />
                                    <a href={einladungMitgliederversammlung2021} target="_blank" download><img src={pdf} alt="PDF" className="height50px" /></a>
                                    <br />
                                    Einladung
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">November 2021</span>
                                    <br />
                                    <h3>Es hat sich wieder was getan...</h3>
                                    ... auch wenn derzeit keine gemeinsamen Veranstaltungen im Kindergarten stattfinden können, ist der Förderverein nicht untätig.
                                    <h2>
                                        Neue Spielwand bei den Wichteln
                                    </h2>
                                    <br />
                                    Die kleinen Wichtel dürfen sich über die neue Spielwand im Außenbereich freuen.
                                    <br />
                                    <img src={spielwandWichtel} alt="Spielwand Wichtel" className="img-fluid" />
                                    <br />
                                    <br />
                                    An diesen Funktionswänden können die Wichtel Ihre motorischen Fähigkeiten präsentieren und natürlich auch ordentlich Musik machen.
                                    <br />
                                    Wir sind sicher, die Kinder werden viel Spaß mit den neuen Spielwand haben.
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>

                                <div>
                                    <span className="badge badge-primary">November 2020</span>
                                    <br />
                                    <h3>Schon gewusst?</h3>
                                    <h2>
                                        Eine Toniebox für unsere KiTa!
                                    </h2>
                                    <br />
                                    Um die Leseecke der KiTa noch etwas abwechslungsreicher zu gestalten hat der Förderverein vor Kurzem eine Toniebox und einige Tonies angeschafft.
                                    <br />
                                    Neben einigen Geschichten-Tonies gibt es auch Musik-Tonies, die für die kleinen und größeren Kinder ab sofort in der Leseecke eingezogen sind.
                                    <br />
                                    <br />
                                    <img src={tonies} alt="Tonies" className="img-fluid" />
                                    <br />
                                    <br />
                                    Wir wünschen den Kindern viel Freude beim Hören!
                                    
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">Oktober 2020</span>
                                    <br />
                                    <h2>
                                        Einladung zur Mitgliederversammlung
                                    </h2>
                                    <br />
                                    Liebe Mitglieder*innen,
                                    <br />
                                    aufgrund der aktuellen Corona-Situation haben wir uns dazu entschlossen, die diesjährige Mitgliederversammlung des Fördervereins der Städtischen Kindertagesstätte Bongartzstift e.V. im Rahmen einer Videokonferenz durchzuführen. Aus organisatorischen Gründen verschiebt sich daher der Termin wie folgt:
                                    <br />
                                    <br />
                                    <Bold>Termin: 4. November 2020 um 19:00 Uhr</Bold>
                                    <br />
                                    <br />
                                    Die Tagesordnung bleibt unverändert.
                                    <br />
                                    Anträge auf Ergänzungen der Tagesordnung müssen vor der Versammlung beim Vorstand eingereicht werden.
                                    <br />
                                    <br />
                                    Technik: Um einen reibungslosen Ablauf zu gewährleisten ist eine schriftliche Anmeldung per Email an unsere folgende Emailadresse notwendig: <EmailAddress classNames={""} emailAddress={"foerderverein-bongartzstift@web.de"} key={"newsEmailAddressOctober2020"} />
                                    Jeder erhält vorab einen Einladungslink, durch den man problemlos an der Videokonferenz (via Microsoft Team) teilnehmen kann – es ist keine Installation einer Software notwendig. Zur Teilnahme benötigen Sie lediglich einen Internetanschluss sowie ein Endgerät (PC, Laptop, Tablet oder Mobiltelefon)
                                    Wir danken Ihnen für Ihr Verständnis und freuen uns Sie an diesem Tag zahlreich online begrüßen zu können.
                                    <br />
                                    <br />
                                    Gemeinsam können wir für die Kinder der Kita viel erreichen!
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">September 2019</span>
                                    <br />
                                    <h2>
                                        Schon gewusst? Ein neues Spielhaus in der Kita!
                                    </h2>
                                    <br />
                                    W&auml;hrend der Sommerferien hat sich in der Kita was getan…
                                    <br /> 
                                    Viele haben es vermutlich schon entdeckt!
                                    <br />
                                    Wir freuen uns Ihnen endlich die neuste Anschaffung f&uuml;r die kleinen Entdecker zeigen zu k&ouml;nnen. Ein Spielhaus mit Kletterelementen, H&auml;ngebr&uuml;cke, Kuschelh&ouml;hle und Geheimversteck wurde durch die gro&szlig;z&uuml;gige Unterst&uuml;tzung der Firma Henkel und des F&ouml;rdervereins realisiert.
                                    <br />
                                    <br />
                                    <img src={spielhaus} className="img-fluid" alt="Spielhaus" />
                                </div>
                                <Padding50px>
                                    <hr />
                                </Padding50px>
                                <div>
                                    <span className="badge badge-primary">Mai 2019</span>
                                    <br />
                                    <h2>
                                        Ein Sonnensegel f&uuml;r unsere Kita!
                                    </h2>
                                    <br />
                                    Der Wunsch nach einer Beschattung des Au&szlig;engel&auml;ndes durch ein Sonnensegel war schon seit l&auml;ngerer Zeit gro&szlig;. Durch gro&szlig;z&uuml;gige Spenden der Firma Henkel und die Arbeit des F&ouml;rdervereins konnte nun endlich, p&uuml;nktlich zu Beginn dieses Sommers, das neue Sonnensegel im Sandspiel-Bereich der Gruppen Gelb und Gr&uuml;n montiert werden. 
                                    <br />
                                    <br />
                                    <img src={segel} className="img-fluid" alt="Sonnensegel" />
                                    <br />
                                    <br />
                                    Unser neues Sonnensegel hat eine Gr&ouml;&szlig;e von ca. 14 m² und bietet den Kindern zus&auml;tzlichen Sonnenschutz in der Sandspielfl&auml;che. Das Material des Sonnensegels beinhaltet einen getesteten UV-Schutz und erh&ouml;ht ab sofort, zus&auml;tzlich zu dem Schutz durch Sonnencreme, den Schutz der empfindlichen Kinderhaut gegen die Sonneneinstrahlung.
                                    <br />
                                    Wir bedanken uns bei allen Unterst&uuml;tzern des Projektes und w&uuml;nschen unseren Kindern viel Spa&szlig; beim Spielen im Sand.
                                </div>
                            </Background>
                        </div>
                    </div>
                </div>
            </div>
    	);
  	}
}

export default News;


// WEBPACK FOOTER //
// ./src/components/news.component.js